export default "__VITE_ASSET__5fa9d498__"